import { Reveal } from "@/components/Reveal";
import { JobberEmbed } from "@/components/JobberEmbed";
import { CONTACT } from "@/data";

export const QuoteForm = () => {
  return (
    <section id="quote" data-testid="quote-section" className="bg-gold py-24 md:py-32">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 grid md:grid-cols-12 gap-10 md:gap-16 items-start">
        <Reveal className="md:col-span-5">
          <p className="font-primary uppercase tracking-[0.3em] text-navy/60 text-xs md:text-sm mb-4">Get In Touch</p>
          <h2 className="font-primary font-bold uppercase tracking-tighter text-navy text-5xl md:text-7xl leading-[0.88] mb-6">
            Send Us<br />A Photo.
          </h2>
          <p className="font-body text-navy/80 text-lg leading-relaxed mb-8 max-w-md">
            Fill out the request form and add a photo of your mailbox or project — we'll get you a
            quote, usually the same day.
          </p>
          <div className="space-y-2 font-primary uppercase tracking-tight text-navy text-xl md:text-2xl">
            <a href={CONTACT.phoneHref} data-testid="quote-call-link" className="block hover:underline">{CONTACT.phone}</a>
            <a href={`mailto:${CONTACT.email}`} data-testid="quote-email-link" className="block text-lg lowercase hover:underline">{CONTACT.email}</a>
          </div>
        </Reveal>

        <Reveal delay={0.1} className="md:col-span-7 w-full">
          <div className="bg-ice p-5 md:p-8">
            <JobberEmbed />
          </div>
        </Reveal>
      </div>
    </section>
  );
};
